var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 11.25H1.875C1.52982 11.25 1.25 11.5298 1.25 11.875V18.125C1.25 18.4702 1.52982 18.75 1.875 18.75H5.625C5.97018 18.75 6.25 18.4702 6.25 18.125V11.875C6.25 11.5298 5.97018 11.25 5.625 11.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 6.25H14.375C14.0298 6.25 13.75 6.52982 13.75 6.875V18.125C13.75 18.4702 14.0298 18.75 14.375 18.75H18.125C18.4702 18.75 18.75 18.4702 18.75 18.125V6.875C18.75 6.52982 18.4702 6.25 18.125 6.25Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 1.25H8.125C7.77982 1.25 7.5 1.52982 7.5 1.875V18.125C7.5 18.4702 7.77982 18.75 8.125 18.75H11.875C12.2202 18.75 12.5 18.4702 12.5 18.125V1.875C12.5 1.52982 12.2202 1.25 11.875 1.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.db1e02ef955ffa5aa8441442db27cd08.svg";
export { ForwardRef as ReactComponent };